import menu from "./components/menu.js"
import sideNav from "./components/sideNav.js"
import map from "./components/map.js"
import parks from "./components/parks.js"
import news from "./components/news.js"
import events from "./components/events.js"
import glossary from "./components/glossary.js"
import forms from "./components/forms.js"
import alertBar from "./components/alertBar.js"
import socialMedia from "./components/socialMedia.js"
import projects from "./components/projects.js"
import skipLinks from "./components/skipLinks.js"
import accordion from "./components/accordion.js"
import table from "./components/table.js"
import tooltip from "./components/tooltip.js"
import { wind } from "./helpers.js"
import video from "./components/video.js"
import accessibilityshim from "./components/accessibility-shim"
import mobileMenu from "./components/mobile-menu"
import shielded from "./components/shielded"
import securityTabs from "./components/security-tabs"
import linkWithHash from "./components/link-with-hash.js"
import collapse from "./collapse"

document.addEventListener("DOMContentLoaded", function() {
  menu()
  sideNav()
  map("ParkPage")
  map("ProjectPage")
  parks()
  news()
  events()
  glossary()
  forms()
  alertBar()
  socialMedia()
  projects()
  table()
  wind()
  skipLinks()
  video()
  accordion()
  accessibilityshim()
  mobileMenu()
  securityTabs()
  shielded()
  collapse()
  tooltip()
  linkWithHash()
})
